<template>
  <v-container
    v-if="isInternalUser"
    class="internal-table-filter"
    fluid
  >
    <org-filter-form v-if="reportKey === 'organizations' && internalModuleReady" />

    <person-filter-form v-if="reportKey === 'people' && internalModuleReady" />

    <project-filter-form v-if="reportKey === 'projects' && internalModuleReady" />

    <time-filter-form v-if="reportKey === 'time' && internalModuleReady" />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import ensureModuleRegistered from '@/utils/store'
import OrgFilterForm from './OrgFilterForm'
import PersonFilterForm from './PersonFilterForm'
import ProjectFilterForm from './ProjectFilterForm.vue'
import TimeFilterForm from './TimeFilterForm'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters } = createNamespacedHelpers('tools')

const INTERNAL_REPORT_KEYS = ['organizations', 'people', 'projects', 'time']

export default {
  name: 'InternalFilterForm',
  components: {
    OrgFilterForm,
    PersonFilterForm,
    ProjectFilterForm,
    TimeFilterForm,
  },
  data() {
    return {
      // reportKey resolves synchronously from the route, but the 'internal' Vuex
      // module it depends on is registered asynchronously elsewhere (see
      // tools/registerStore, triggered by navigation via SearchBar.vue). Rendering
      // these child filter forms before that finishes throws a Vuex
      // "module namespace not found in mapState(): internal/" warning.
      internalModuleReady: this.$store.hasModule('internal'),
    }
  },
  computed: {
    ...mapAuthGetters(['isInternalUser']),
    ...mapGetters(['reportKey']),
  },
  watch: {
    reportKey: {
      immediate: true,
      handler(reportKey) {
        if (this.internalModuleReady || !INTERNAL_REPORT_KEYS.includes(reportKey)) {
          return
        }

        this.waitForInternalModule()
      },
    },
  },
  methods: {
    async waitForInternalModule() {
      this.internalModuleReady = await ensureModuleRegistered(this.$store, 'internal')
    },
  },
}
</script>
